import React, { useCallback, useEffect, useMemo, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import { toast } from "sonner";
import { Plus, Trash2, X, Megaphone } from "lucide-react";
import { formatTanggal } from "@/lib/api";

export default function Pemberitahuan() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ isi: "", penerima_type: "semua_guru", penerima_id: "" });
  const [guru, setGuru] = useState([]); const [siswa, setSiswa] = useState([]);

  const load = useCallback(async () => {
    const [{ data }, { data: g }, { data: s }] = await Promise.all([api.get("/pemberitahuan"), api.get("/guru"), api.get("/siswa")]);
    setItems(data); setGuru(g); setSiswa(s);
  }, []);
  useEffect(() => { load(); }, [load]);

  const guruAktif = useMemo(() => guru.filter(g => g.status === "aktif"), [guru]);
  const siswaAktif = useMemo(() => siswa.filter(s => s.status === "aktif"), [siswa]);

  const guruMap = useMemo(() => {
    const m = {}; guru.forEach(g => { m[g.id] = g.nama; }); return m;
  }, [guru]);
  const siswaMap = useMemo(() => {
    const m = {}; siswa.forEach(s => { m[s.id] = s.nama; }); return m;
  }, [siswa]);

  const labelPenerima = (p) => {
    if (p.penerima_type === "semua_guru") return "Seluruh Guru";
    if (p.penerima_type === "semua_siswa") return "Seluruh Siswa";
    if (p.penerima_type === "guru_tertentu") return `Guru: ${guruMap[p.penerima_id] || "—"}`;
    if (p.penerima_type === "siswa_tertentu") return `Siswa: ${siswaMap[p.penerima_id] || "—"}`;
    return p.penerima_type;
  };

  const submit = async (e) => {
    e.preventDefault();
    if ((form.penerima_type === "guru_tertentu" || form.penerima_type === "siswa_tertentu") && !form.penerima_id) return toast.error("Pilih penerima");
    try { await api.post("/pemberitahuan", form); toast.success("Pemberitahuan dipublikasikan"); setShow(false); setForm({ isi: "", penerima_type: "semua_guru", penerima_id: "" }); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { if (!window.confirm("Hapus pemberitahuan?")) return; await api.delete(`/pemberitahuan/${id}`); toast.success("Dihapus"); load(); };

  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Pemberitahuan" action={
        <button onClick={() => setShow(true)} className="pp-btn-primary" data-testid="open-pemb"><Plus className="w-4 h-4" />Input Pemberitahuan</button>
      } />

      {show && (
        <section className="pp-card p-6 mb-6 animate-fade-up">
          <div className="flex items-center justify-between mb-5"><h3 className="text-lg font-semibold">Buat Pemberitahuan</h3><button onClick={() => setShow(false)}><X className="w-5 h-5 text-slate-400" /></button></div>
          <form onSubmit={submit} className="space-y-4" data-testid="pemb-form">
            <div><label className="pp-label">Pilih Penerima</label>
              <select className="pp-input" value={form.penerima_type} onChange={(e) => setForm({...form, penerima_type: e.target.value, penerima_id: ""})} data-testid="pemb-type">
                <option value="semua_guru">Seluruh Guru</option>
                <option value="semua_siswa">Seluruh Siswa</option>
                <option value="guru_tertentu">Guru Tertentu</option>
                <option value="siswa_tertentu">Siswa Tertentu</option>
              </select></div>
            {form.penerima_type === "guru_tertentu" && (
              <div><label className="pp-label">Pilih Guru</label>
                <select className="pp-input" value={form.penerima_id} onChange={(e) => setForm({...form, penerima_id: e.target.value})}>
                  <option value="">Pilih guru</option>{guruAktif.map(g => <option key={g.id} value={g.id}>{g.nama}</option>)}
                </select></div>
            )}
            {form.penerima_type === "siswa_tertentu" && (
              <div><label className="pp-label">Pilih Siswa</label>
                <select className="pp-input" value={form.penerima_id} onChange={(e) => setForm({...form, penerima_id: e.target.value})}>
                  <option value="">Pilih siswa</option>{siswaAktif.map(s => <option key={s.id} value={s.id}>{s.nama}</option>)}
                </select></div>
            )}
            <div><label className="pp-label">Isi Pemberitahuan *</label><textarea required rows={5} className="pp-input" value={form.isi} onChange={(e) => setForm({...form, isi: e.target.value})} data-testid="pemb-isi" /></div>
            <div className="flex justify-end gap-2"><button type="button" onClick={() => setShow(false)} className="pp-btn-secondary">Batal</button><button type="submit" className="pp-btn-primary" data-testid="submit-pemb">Publikasikan</button></div>
          </form>
        </section>
      )}

      <section className="space-y-4" data-testid="pemb-list">
        {items.length === 0 && <div className="pp-card p-12 text-center italic text-slate-400">Belum ada pemberitahuan.</div>}
        {items.map((p) => (
          <article key={p.id} className="pp-card p-5 sm:p-6">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="flex items-center gap-2"><Megaphone className="w-4 h-4 text-indigo-600" />
                <span className="pp-badge-info" data-testid={`pemb-target-${p.id}`}>{labelPenerima(p)}</span>
              </div>
              <button onClick={() => del(p.id)} className="pp-btn-danger"><Trash2 className="w-3.5 h-3.5" />Hapus</button>
            </div>
            <p className="text-slate-800 whitespace-pre-wrap mb-3">{p.isi}</p>
            <div className="text-xs text-slate-500 pt-3 border-t border-slate-100">— {p.posted_by_nama} · {formatTanggal(p.created_at)}</div>
          </article>
        ))}
      </section>
    </Layout>
  );
}
